/**
 * Auth V2 — cookie consent is platform-wide (one decision for the whole PWA).
 */
import { PLATFORM_CHROME_TENANT_CODE } from '../../app/platformChromeTenant.js';

/** Canonical localStorage partition for CMP decisions + reject-until. */
export const PLATFORM_CONSENT_STORAGE_TENANT = PLATFORM_CHROME_TENANT_CODE;

/** Map browse tenant to the single platform consent bucket. */
export function resolveConsentStorageTenantCode(_browseTenantCode?: string): string {
  return PLATFORM_CONSENT_STORAGE_TENANT;
}
